<template>
  <div>
    <div class="my_coupon">
      <div class="my_coupon_title">我的优惠券</div>
      <div class="clearfix_ my_coupon_box">
        <div class="fl my_coupon_num">{{total}}<span style="font-size:18px;color:#666;">&nbsp;&nbsp;张</span></div>
        <div class="fl clearfix_ my_coupon_btn">
          <div @click="goToCouponList(tenantId)" class="fl">领券中心>></div>
          <div @click="goToHistoryCoupon(tenantId)" class="fl">优惠券历史>></div>
        </div>
        <div class="clearfix_ fr my_coupon_sort_box">
          <div @click="newestSort" class="fl my_coupon_sort_newest clearfix_">
            <div :class="{'my_coupon_sort_txt_active':sortColor==1}" class="fl my_coupon_sort_txt">最新</div>
            <div class="fl my_coupon_sort_img">
              <img v-show="newestSortImgShow" :src="newestSortImg" alt="">
            </div>
          </div>
          <div @click="overdueSort" class="fl my_coupon_sort_overdue clearfix_">
            <div :class="{'my_coupon_sort_txt_active':sortColor==2}" class="fl my_coupon_sort_txt">即将过期</div>
            <div class="fl my_coupon_sort_img">
              <img v-show="overdueSortImgShow" :src="overdueSortImg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my_coupon_list clearfix_">
      <div style="width:240px;" v-for="(item,index) in couponList" :key="index" class="my_coupon_list_item fl">
        <div class="my_coupon_list_item_time">到期时间：{{item.pastDate}}</div>
        <div style="width:240px;height:65px;" class="coupon_list_item_box">
          <div @click="goToCouponDetail(item.id)" class="my_coupon_goto"></div>
          <div style="width:240px;height:65px;" class="coupon_list_item_box_img">
            <img style="width:240px;height:65px;" v-show="parseFloat(item.price)>0&&parseFloat(item.price)<50" :src="newCouponBg1" alt="">
            <img style="width:240px;height:65px;" v-show="parseFloat(item.price)>=50&&parseFloat(item.price)<100" :src="newCouponBg2" alt="">
            <img style="width:240px;height:65px;" v-show="parseFloat(item.price)>=100" :src="newCouponBg3" alt="">
          </div>
          <div class="new_coupon_list_item_box_rmb">¥</div>
          <div v-show="item.price.length==1" class="new_coupon_list_item_box_price">{{item.price}}</div>
          <div v-show="item.price.length==2" class="new_coupon_list_item_box_price_active_len2">{{item.price}}</div>
          <div v-show="item.price.length==3" class="new_coupon_list_item_box_price_active_len3">{{item.price}}</div>
          <div v-show="item.price.length>=4" class="new_coupon_list_item_box_price_active_len4">{{item.price}}</div>
          <div style="font-size:14px;top:10px;left:105px;" class="coupon_list_item_box_conditions"><span>{{item.condition}}</span> <span style="color:#a75212;">{{item.goodsNum}}</span> <span>{{item.method}}可用</span></div>
          <div style="font-size:12px;top:40px;left:20px;color:#fff;" class="coupon_list_item_box_scope">{{item.useRange}}</div>
          <div class="my_coupon_item_time">{{item.pastDate}}</div>
          <div style="top:1px;right:1px;width:20px;height:auto;line-height:14px;color:#f12002;background:#fff;text-align:center;cursor: pointer;border-left:1px dashed #ccc;padding:3px 2px;" @click="goToCouponDetail(item.id)" class="coupon_list_item_box_use">立即使用</div>
        </div>
      </div>
    </div>
    <div class="no_data" v-if="total==0">暂无数据</div>
    <div class="my_coupon_pages">
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-size="12"
          layout="prev, pager, next, jumper"
          :total="this.total">
        </el-pagination>
      </div> 
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      myCoupon:require('../../assets/img/my_coupon.png'),
      newCouponBg1:require('../../assets/img/coupon240_1.png'),
      newCouponBg2:require('../../assets/img/coupon240_2.png'),
      newCouponBg3:require('../../assets/img/coupon240_3.png'),
      page:1,
      total:null,
      couponList:[],
      tenantId:'',
      couponNum:0,
      sortColor:1,
      newestSortImg:'http://img.source.9188cn.com/my_coupon_down.png',
      newestSortImgShow:1,
      newestSortNum:1,
      overdueSortImg:'',
      overdueSortImgShow:0,
      overdueSortNum:2,
      sortName:'time'
    }
  },
  mounted:function(){
    this.tenantId=this.$route.query.tenantId
    this.getMyCoupon(this.page)
  },
  methods:{
    newestSort:function(){
      var t_=this
      t_.page=1
      t_.couponList=[]
      t_.sortColor=1
      t_.newestSortImgShow=1
      t_.overdueSortImgShow=0
      t_.sortName='time'
      if(t_.newestSortNum==1){
        t_.newestSortNum=2
        t_.newestSortImg='http://img.source.9188cn.com/my_coupon_up.png'
      }else{
        t_.newestSortNum=1
        t_.newestSortImg='http://img.source.9188cn.com/my_coupon_down.png'
      }
      t_.getMyCoupon(t_.page)
    },
    overdueSort:function(){
      var t_=this
      t_.page=1
      t_.couponList=[]
      t_.sortColor=2
      t_.newestSortImgShow=0
      t_.overdueSortImgShow=1
      t_.sortName='pastDate'
      if(t_.overdueSortNum==1){
        t_.overdueSortNum=2
        t_.overdueSortImg='http://img.source.9188cn.com/my_coupon_up.png'
      }else{
        t_.overdueSortNum=1
        t_.overdueSortImg='http://img.source.9188cn.com/my_coupon_down.png'
      }
      t_.getMyCoupon(t_.page)
    },
    goToCouponDetail:function(id){
      var t_=this
      var href=this.$router.resolve({name:'couponDetail',query:{id:id,tenantId:t_.tenantId}})
      return window.open(href.href,'_blank')
    },
    goToCouponList:function(tenantId){
      var t_=this
      var href=this.$router.resolve({name:'couponList',query:{tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    goToHistoryCoupon:function(tenantId){
      var t_=this
      var href=this.$router.resolve({name:'historyCoupon',query:{tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.page=val
      this.couponList=[]
      this.getMyCoupon(val)
    },
    getMyCoupon:function(page){
      var t_=this
      var data0bj={
        page:page,
        pagesize:12,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        tenantId:t_.$route.query.tenantId,
        sortName:t_.sortName
      }
      if(data0bj.sortName=='time'){
        data0bj.sort=t_.newestSortNum
      }else{
        data0bj.sort=t_.overdueSortNum
      }
      axios.post(`${ip}formWorkInterface/getMemberCouponList`,Qs.stringify(data0bj)).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          res.data.couponList.forEach(function(item,index){
            item.price=item.price.toString()
          },t_)
          t_.couponNum=res.data.num
          t_.total=res.data.total,
          t_.couponList=res.data.couponList
        }
      })
    }
  }
}
</script>
<style>
  .my_coupon{
    border-bottom:1px solid #ccc;
  }
  .my_coupon_title{
    padding: 20px 0 40px 0;
    font-size: 20px;
  }
  .my_coupon_num{
    color:#f12002;
    font-size: 30px;
    margin-left: 130px;
  }
  .my_coupon_btn{
    margin-left: 160px;
    margin-top: 15px;
    cursor: pointer;
    font-size:14px;
  }
  .my_coupon_btn div:nth-child(2){
    margin-left: 65px;
  }
  .my_coupon_box{
    padding-bottom: 20px;
  }
  .my_coupon_list{
    padding: 20px 0;
  }
  .my_coupon_list_item{
    width: 330px;
    margin: 0 23px 20px 0;
  }
  .my_coupon_list_item:nth-child(4n){
    margin: 0 0 20px 0;
  }
  .my_coupon_list_item_time{
    margin-left: 10px;
    margin-bottom: 15px;
  }
  .coupon_list_item_box{
    width:330px;
    height:104px;
    position: relative;
  }
  .coupon_list_item_box_img{
    width:330px;
    height:104px;
    position: absolute;
    top:0;
    left:0;
  }
  .coupon_list_item_box_img img{
    width:330px;
    height:104px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_rmb{
    position: absolute;
    top:21px;
    left:10px;
    color:#fff;
    font-size: 20px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price{
    position: absolute;
    top:10px;
    left: 36px;
    color:#fff;
    font-size:34px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price_active_len2{
    position: absolute;
    top:10px;
    left: 29px;
    color:#fff;
    font-size:34px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price_active_len3{
    position: absolute;
    top:13px;
    left: 24px;
    color:#fff;
    font-size:32px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price_active_len4{
    position: absolute;
    top:17px;
    left: 23px;
    color:#fff;
    font-size:26px;
  }
  .coupon_list_item_box_conditions{
    position: absolute;
    width:100px;
    top:15px;
    left:165px;
    font-size:18px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight: 900;
    color:#66604a;
  }
  .coupon_list_item_box_scope{
    position: absolute;
    top:57px;
    left:165px;
    font-size:16px;
    height: 22px;
    line-height: 22px;
  }
  .coupon_list_item_box_use{
    position: absolute;
    top:57px;
    right:20px;
    width: 72px;
    height: 22px;
  }
  .no_data{
    text-align: center;
    padding: 20px 0;
  }
  .my_coupon_item_time{
    position: absolute;
    top:40px;
    left:105px;
    color:#ababab;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100px;
  }
  .my_coupon_goto{
    width: 214px;
    height: 65px;
    position: absolute;
    top:0;
    left:0;
    z-index: 9;
    cursor: pointer;
  }
  .my_coupon_pages{
    text-align: center;
    padding-bottom: 10px;
  }
  .my_coupon_sort_txt{
    font-size:14px;
    cursor: pointer;
  }
  .my_coupon_sort_txt_active{
    color:#dd2c3a;
  }
  .my_coupon_sort_img{
    width: 18px;
    height: 18px;
    margin-top: -2px;
  }
  .my_coupon_sort_img img{
    width: 18px;
    height: 18px;
  }
  .my_coupon_sort_box{
    margin-top: 15px;
  }
  .my_coupon_sort_newest{
    margin-right: 15px;
  }
  .my_coupon_sort_overdue{
    margin-right: 25px;
  }
  .my_coupon_pages .el-pagination__jump{
    margin-top: -9px;
  }
  .my_coupon_pages .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/coupon/my_coupon.vue